<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g>
      <path fill="#fff" d="M0 0h32v32h-32v-32z" />
      <path
        fill="#4365e2"
        d="M25.15 10.256h-17.638c-0.133 0-0.24-0.107-0.24-0.24v0-0.976c0-0.133 0.107-0.24 0.24-0.24v0h17.638c0.133 0 0.24 0.107 0.24 0.24v0 0.97c0 0.133-0.107 0.24-0.24 0.24v0zM25.15 16.728h-17.638c-0.133 0-0.24-0.107-0.24-0.24v0-0.974c0-0.133 0.107-0.24 0.24-0.24h17.638c0.133 0 0.24 0.107 0.24 0.24v0 0.97c0 0.133-0.107 0.24-0.24 0.24v0zM25.15 23.2h-17.638c-0.133 0-0.24-0.107-0.24-0.24v0-0.974c0-0.133 0.107-0.24 0.24-0.24h17.638c0.133 0 0.24 0.107 0.24 0.24v0 0.974c0 0.133-0.107 0.24-0.24 0.24v0z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
